reIsOctal